<template>
    <RemoteComponent component="ShareBar" />
 </template>
 
 <script>
 import RemoteComponent from '@/components/RemoteComponent.vue'
 export default {
     name: 'ShareBar',
     components: {
         RemoteComponent
     },
     data () {
         return {
         
         }
     },
     mounted () {
     
     },
     methods: {
        
     },
 }
 </script>
 <style>
 </style>